import RectangleMesh from "../../instancing/Meshes/RectangleMesh";
import { structuralVariantsDbs } from "../../constants/dbs";
import getMaterialWithUniforms from "../../instancing/materials/getMaterialWithUniforms";
import DbCategoryColorScale from "../../models/DbCategoryColorScale";

const dbs = Object.values(structuralVariantsDbs);
export const colorMap = new DbCategoryColorScale(dbs);
const { vectors } = colorMap;

export function getStructuralVariantsMesh() {
  const conf = {
    rgbaCode: 1,
    raycastInd: 1,
    posX: 1,
    posY: 1,
  };
  const materialConf = getMaterialWithUniforms({})
    .setPaddingX([-1, 1, -1, 1])
    .setPaddingY([-3, -3, 3, 3])
    .setOffset([0, 0])
    .setColorMap(vectors);
  return new RectangleMesh(materialConf, conf);
}

export function updateExisting(items, mesh) {
  const setY = mesh.updateY({ count: items.length, isAppend: false });
  for (let i = 0; i < items.length; i++) {
    const y = items[i].level;
    setY(i, y, y, y, y);
  }
}

export function drawVariant(items, mesh) {
  const count = items.length;
  const isAppend = true;
  const setX = mesh.updateX({ count, isAppend });
  const setY = mesh.updateY({ count, isAppend });
  const setRgb = mesh.updateRgba({ count, isAppend });
  for (let i = 0; i < count; i++) {
    const cnv = items[i];
    const y = cnv.level;
    const { g0, g1 } = cnv.region;
    const x0 = g0;
    const x1 = g1;
    const rgb = colorMap.getKey(cnv.db.key).ind;
    setX(i, x0, x1, x0, x1);
    setY(i, y, y, y, y);
    setRgb(i, rgb, rgb, rgb, rgb);
  }
}
